import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "checkmark_svg__icon checkmark_svg__icon--checkmark"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.465 6.24a.75.75 0 0 1 .123 1.054l-7.839 9.918a1.799 1.799 0 0 1-2.916-.085l-2.446-3.471a.75.75 0 1 1 1.226-.864l2.45 3.477.01.015a.299.299 0 0 0 .487.014l.009-.011 7.843-9.923a.75.75 0 0 1 1.053-.123Z",
    clipRule: "evenodd"
  })));
};

export { SvgCheckmark as default };
//# sourceMappingURL=checkmark.svg.js.map
